var map = {
	"./airtel.svg": 9415,
	"./amazon.svg": 5104,
	"./freecharge.svg": 8366,
	"./icici.svg": 8717,
	"./jio.svg": 6742,
	"./mobikwik.svg": 1925,
	"./ola.svg": 6582,
	"./paytm.svg": 8103,
	"./phonepe.svg": 3813
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4926;